import { OptionsNgxOwCarouselService } from 'dmmp-services'
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-banner-full',
  templateUrl: './banner-full.component.html',
})
export class BannerFullComponent implements OnInit {

  @Input() identifier
  @Input() data
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  configCarousel
  bannerHeight = 'banner-height-changed'

  constructor(private options: OptionsNgxOwCarouselService) {
  }

  ngOnInit() {
    this.configCarousel = this.options.configurationBenefits(this.data)
    this.hasImageOrVideo()
  }


  hasImageOrVideo() {
    if (this.data?.content?.length > 0) {
      this.data?.content?.filter(element => {
        element?.row?.find(rowElement => {
          rowElement?.columns?.find(columnElement => {
            columnElement?.items?.find(itemElement => {
              if (itemElement?.identifier === 'banner_video' || itemElement?.identifier === 'images_link') {
                this.bannerHeight = ''
              }
            })
          })
        })
      })
    }
  }
}
